/**
 * 首页每日精选
 */
<template>
  <div
    class="home-page-daily-select"
    v-if="dailySelect && dailySelect.length"
    :clstag="'jr|keycount|yxsc_home_homePageDailySelect|area'"
  >
    <img
      :src="dailySelectTitleImgSrc"
      class="title-img"
    >
    <div class="daily-content">
      <!-- <VerticalSlide
                :sum="sum"
                :loop="false"
                :data="dailySelect"
                :widthType="2"
                :offsetWidth="30"
                ref="dailyContent"
            >
                <KPL
                    v-for="(item,index) in dailySelect"
                    :key="item.id"
                    :url="item.jumpUrl"
                    :sku="item.skuId"
                    :clstag="'jr|keycount|8530052_index_daailybest|'+index+'_'+item.skuId"
                    :eventId="'MInterestFree_DailySelected'"
                    :eventParam="item.rule"
                >
                    <div class="cls-card">
                        <span
                            class="act-mian installment-lablel tran"
                            v-if="item.isForInterestFree && item.installment > 0"
                        >{{flagName}}{{item.installment}}个月免息</span>
                        <span
                            class="act-mian installment-lablel tran"
                            v-else-if="item.installment > 0"
                        >{{item.installment}}个月免息</span>

                        <div class="home-silder-img-bg">
                            <img
                                class="act-banner1 act-wthhtg256 act-watch"
                                v-lazy="item.imageUrl"
                                :key="item.imageUrl"
                            >
                        </div>
                        <div class="jrm-bfc desp-box">
                            <p class="desp-name act-box">
                                <span
                                    v-if="item.isSelfService"
                                    class="ui-selfRed"
                                >自营</span>
                                {{item.goodsName}}
                            </p>
                            <p class="desp-prize">
                                <span class="act-everyMonth">每月</span>
                                <span class="act-newMonth24">￥</span>
                                <span class="act-newMonth">{{item.installmentPrice}}</span>
                            </p>
                        </div>
                    </div>
                </KPL>
            </VerticalSlide> -->
      <swiper
        :options="isJDapp?swiperOptionJd :swiperOption"
        ref="dailyContent"
        id="swiper"
        class="swiper-container"
      >
        <swiper-slide
          class="slider-item"
          v-for="(item,index) in dailySelect"
          :key="item.id"
          :clstag="'jr|keycount|8530052_index_daailybest|'+index+'_'+item.skuId"
        >
          <div class="cls-card">
            <span
              class="act-mian installment-lablel tran"
              v-if="item.isForInterestFree && item.installment > 0"
            >{{flagName}}{{item.installment}}个月免息</span>
            <span
              class="act-mian installment-lablel tran"
              v-else-if="item.installment > 0"
            >{{item.installment}}个月免息</span>

            <div class="home-silder-img-bg">
              <img
                class="act-banner1 act-wthhtg256 act-watch"
                :src="item.imageUrl"
              >
            </div>
            <div class="jrm-bfc desp-box">
              <p class="desp-name act-box">
                <span
                  v-if="item.isSelfService"
                  class="ui-selfRed"
                >自营</span>
                {{item.goodsName}}
              </p>
              <p class="desp-prize">
                <span class="act-everyMonth">每月</span>
                <span class="act-newMonth24">￥</span>
                <span class="act-newMonth">{{item.installmentPrice}}</span>
              </p>
            </div>
          </div>
        </swiper-slide>
      </swiper>

    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import 'swiper/dist/css/swiper.css';
import request from '@/util/request';
import VerticalSlide from '@/components/VerticalSlide.vue';
import KPL from '@/buscomponents/KPL';
import { getQuery } from '@/util/url';
import { openByKpl } from '../util/kpl';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { isIphonex } from '@/util/common';
import { PostSever } from '@/util/sqRequestService';

const dailySelectTitleImgSrc =
  (window['data_source_100001014'] && window['data_source_100001014'].dailySelectTitleImgSrc) || '//img12.360buyimg.com/jrpmobile/jfs/t1/841/24/11219/4626/5bcd79c3E5363cfa2/bb8d12b896d688c6.jpg';
let self = null;
export default {
  name: 'HomePageDailySelect',
  components: {
    VerticalSlide,
    KPL,
    swiper,
    swiperSlide
  },
  props: {},
  data() {
    return {
      dailySelectTitleImgSrc,
      sum: 2.7,
      dailySelect: [],
      flagName: '专享',
      coverSku: '',
      isJDapp: $ && $.device && $.device.jdapp,
      iphonex: isIphonex() ? true : false,
      swiperOption: {
        slidesPerView: 'auto',
        // loopedSlides: 2,
        slidesPerGroup: 2,
        // centeredSlides: true,
        // spaceBetween: '10%',
        notNextTick: true,
        speed: 1000,
        offsetPxBefore: 100,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        loop: true,
        observer: true
      },
      swiperOptionJd: {
        slidesPerView: 'auto',
        // loopedSlides: 3,
        slidesPerGroup: 1,
        // centeredSlides: true,
        // spaceBetween: '10%',
        notNextTick: true,
        speed: 1000,
        offsetPxBefore: 100,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        loop: true,
        observer: true
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.dailyContent.swiper;
    }
  },
  created() {
    self = this;
    if ($.device && $.device.jdapp) {
      this.flagName = '';
    }
  },
  mounted() {
    let t = setTimeout(() => {
      clearTimeout(t);
      $(document).on('click', '.swiper-slide', function(e) {
        e.preventDefault();
        var index = $(e.currentTarget).attr('data-swiper-slide-index');
        self.handleClickSlide(index);
      });
    }, 2000);
  },
  methods: {
    handleClickSlide(index) {
      const _index = Number(index);
      const item = this.dailySelect[_index];
      let open = openByKpl;
      if(this.$openByKpl){
          open=this.$openByKpl;
      }
      if (item.skuId && !$.device.jdapp) {
        PostSever('//sq.jr.jd.com/cfContent/getCpsLink', {
          skuIds: item.skuId,
          positionId: '1816590445',
          webId: '1277645018'
        }).then(
          rs => {
            open({
              url: rs.value[0].shorUrl,
              sku: item.skuId,
              eventId: 'MInterestFree_DailySelected',
              eventParam: item.rule
            });
          },
          () => {
            open({
              url: item.jumpUrl,
              sku: item.skuId,
              eventId: 'MInterestFree_DailySelected',
              eventParam: item.rule
            });
          }
        );
      } else {
        open({
          url: item.jumpUrl,
          sku: item.skuId,
          eventId: 'MInterestFree_DailySelected',
          eventParam: item.rule
        });
      }
    },

    // 每日精选
    requestDailySelect() {
      var me = this;
      console.log('每日精选');
      let qs = getQuery();
      this.coverSku = qs.sku || '';
      if ($.device.jdjr && qs.skuId && qs.from == 'jdjr') {
        this.coverSku = qs.skuId;
        delete qs.sku;
        delete qs.otherSku;
      }
      if ($.device.jdjr && qs.otherSku && qs.from == 'jdjr') {
        this.coverSku = qs.otherSku;
        delete qs.skuId;
        delete qs.sku;
      }
      request.dailySelect({
        data: {
          coverSku: me.coverSku > 0 ? this.coverSku : ''
        },
        success: rstData => {
          const { recommendGoodsList } = rstData || {};
          if (recommendGoodsList && recommendGoodsList.length) {
            this.dailySelect = recommendGoodsList;
            // setTimeout(() => {
            //   this.dailySelect.splice(0, 0, this.dailyData);
            //   this.$set(this, 'dailySelect', this.dailySelect);
            //   this.$emit('onLoadedDailySelect');
            //   this.$nextTick(() => {
            //     this.$refs.dailyContent.refresh();
            //   });
            // }, 1000);
          }

          this.$emit('onLoadedDailySelect');
        },
        error: () => {
          this.$emit('onLoadedDailySelect');
        }
      });
    }
  },
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>

<style lang="scss">
@import '@/scss/mixin.scss';
$paddingTop: $rem20;

.home-page-daily-select {
  .title-img {
    width: 100%;
    background: #ffffff;
  }
  .ui-selfRed {
    font-family: PingFangSC-Regular;
    font-size: $rem24;
    color: #ffffff;
    background: #f13a4d;
    padding: 0 $rem4;
    line-height: $rem28;
    height: $rem28;
    margin-right: $rem10;
  }
  .act-everyMonth {
    font-family: PingFangSC-Regular;
    font-size: $rem24;
    color: #999999;
    letter-spacing: 0;
  }
  .act-newMonth {
    font-family: PingFangSC-Semibold;
    font-size: $rem28;
    color: #f13a4d;
    letter-spacing: 0;
  }
  .act-newMonth24 {
    font-family: PingFangSC-Semibold;
    font-size: $rem24;
    color: #f13a4d;
    letter-spacing: 0;
  }
  .daily-content {
    // padding-bottom: $rem30;
    background: #ffffff;
    margin-bottom: $rem20;
    margin-top: -$paddingTop;
  }
  .swiper-container {
    padding-bottom: $rem30;
    padding-left: $rem15 !important;
  }

  .slider {
    background-color: transparent !important;
  }
  .slider-group {
    height: $rem450 !important;
    padding-left: $rem32 !important;
    padding-top: $paddingTop !important;
    background-color: transparent !important;
  }

  .home-silder-img-bg {
    width: $rem240;
    height: $rem240;
    overflow: hidden;
    margin: 0 auto;
    margin-bottom: $rem10;
    margin-top: $rem8;
  }

  .act-banner1 {
    width: 100%;
    border-radius: 0;
    text-align: center;
  }

  $clsCardWidth: $rem256;
  $clsCardMarginRight: $rem16;
  .slider-item {
    width: $clsCardWidth + $clsCardMarginRight !important;
    overflow: initial !important;
  }

  .cls-card {
    position: relative;
    width: $clsCardWidth !important;
    height: $rem400 !important;
    margin-right: $clsCardMarginRight;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0 4px 16px 0 rgba(187, 187, 187, 0.3);
  }

  .installment-lablel {
    padding: 0 $rem10;
    width: auto;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }

  .desp-box {
    padding-left: $rem25;
    padding-right: $rem22;
    text-align: left;
  }

  .desp-prize {
    margin-top: $rem10;
  }

  .desp-name {
    height: $rem66;
    font-size: $rem26;
    line-height: $rem34;
    color: #333333;
    letter-spacing: 0;
    word-break: break-all;
  }
}
</style>
